export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.796 4.205v4h6.818l-8.409 8.408 3.181 3.183 8.409-8.409v6.817h4V4.205z\"/>"
};